import { jArticleListSchema, jArticleLittleSchema } from './article';
import { z } from 'zod';

export const jBusinessContactLittleSchema = jArticleLittleSchema.extend({
    type: z.literal('businessContactCard'),
});
export type jBusinessContactLittle = z.infer<typeof jBusinessContactLittleSchema>;

export const jBusinessContactListSchema = jArticleListSchema.and(
    jBusinessContactLittleSchema.and(
        z.object({
            mail: z.string().nullable(),
            pseudo: z.string().nullable(),
            firstName: z.string().nullable(),
            lastName: z.string().nullable(),
            phoneNumber: z.string().nullable(),
            company: z.string().nullable(),
            function: z.string().nullable(),
            champ1: z.string().nullable().optional(),
            champ2: z.string().nullable().optional(),
            champ3: z.string().nullable().optional(),
            champ4: z.string().nullable().optional(),
            champ5: z.string().nullable().optional(),
        }),
    ),
);
export type jBusinessContactList = z.infer<typeof jBusinessContactListSchema>;
